import { Database } from '@nozbe/watermelondb'

export const deleteMessages = async (database: Database) => {
  await database.write(async () => {
    await database.get('messages').query().markAllAsDeleted()
  })
}
